export default __webpack_public_path__ + "static/media/dieppe20.1ca37f75.jpg";